import { Component } from '@theme/component';

class KnoahGroupedDropdown extends Component {
  #resizeObserver;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver?.disconnect();
    this.#resizeObserver = new ResizeObserver(this.#scheduleHeight);
    this.#resizeObserver.observe(this);
    this.#scheduleHeight();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#scheduleHeight();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #scheduleHeight = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(this.#syncHeight);
  };

  #syncHeight = () => {
    this.#frame = 0;
    if (!this.isConnected) return;

    const header = this.closest('.header-menu');
    const item = this.closest('.menu-list__list-item');
    const trigger = item?.querySelector(':scope > .menu-list__link');
    const submenu = this.closest('.knoah-grouped-submenu');
    if (!header || !submenu || trigger?.getAttribute('aria-expanded') !== 'true') return;

    const panel = item.getAttribute('slot') === 'overflow'
      ? header.querySelector('overflow-list')?.shadowRoot?.querySelector('[part="overflow"]')
      : submenu;
    if (!panel) return;

    header.style.setProperty('--submenu-height', `${panel.offsetHeight}px`);
  };
}

if (!customElements.get('knoah-grouped-dropdown')) {
  customElements.define('knoah-grouped-dropdown', KnoahGroupedDropdown);
}